import { AttributeFilters } from '../constants/Translations/AgGrid/AgGrid_sr';

export const getAdditionalFilter = (key, id) => {
  return [
    {
      key: key,
      operation: AttributeFilters?.EQUAL?.value, //TODO proveriti ima li konstanta u nekom utils fajlu za ovo
      value: id,
    },
  ];
};
